<style lang="scss" scoped>
  .Rooms {
     background-color: red;
  }
</style>

<template lang="pug">
  // The template contains a div with AppDrawer and the
  // AppDrawer has dymanic drawer items, each with its own look and feel and business logic
  .Rooms(ref="home")
    MobiWatermarkBackground
    AppDrawer(:drawerItems="drawerItems", title="Back to Rooms", :hideToggleButton="true", :hideHeader="false", backLink="/rooms/")
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import AppDrawer from '../../components/AppDrawer/AppDrawer';
  import MobiWatermarkBackground from '../../components/MobiWatermarkBackground';
  import RoomTitle from './components/RoomTitle';
  import NewARElement from './components/NewARElement';
  import ARElementList from './components/ARElementList';

  export default {
    name: 'Rooms',

    components: {
      MobiWatermarkBackground,
      AppDrawer,
    },
    data() {
      let drawerItems = [];
      drawerItems = this.getAllRoomComponents();
      return {
        drawerItems,
      };
    },
    created() {
      // If a room page is directly accessed the router will redirect it to the ROOMS page.
      const room = this.getRoomById()(this.$route.params.id);
      if (!room) {
        this.$router.push('/rooms');
      }
    },
    methods: {
      ...mapGetters('Firebase', ['getRoomById']),
      ...mapActions('Firebase', ['updateRoomTitle']),
      getTitleComponent() {
        const room = this.getRoomById()(this.$route.params.id);
        const title = room.title;
        return {
          component: RoomTitle,
          props: {
            title,
          },
          onData: this.onTitleChanged,
        };
      },
      getAllRoomComponents() {
        const allComponents = [];
        allComponents.push(this.getTitleComponent());
        allComponents.push(this.getNewARElementTextFieldComponent());
        allComponents.push(this.getItemComponent());
        return allComponents;
      },
      getNewARElementTextFieldComponent() {
        return {
          component: NewARElement,
        };
      },
      getItemComponent() {
        return {
          component: ARElementList,
          props: {
            title: '',
          },
        };
      },
      onTitleChanged(data) {
        // Call the Firebase action to save the new title in store.
        const room = this.getRoomById()(this.$route.params.id);
        const updateObj = {
          ...room,
          title: data,
        };
        this.updateRoomTitle(updateObj);
      },
      onToggleShowHide(data) {
        this.is_active = data;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/Room/Room.vue